<div [matTooltip]="tooltip">
  <button
    mat-icon-button
    [color]="color"
    [disabled]="disabled"
    [ngClass]="buttonClass"
    tabindex="-1"
  >
    @if (svgIcon) {
      <mat-icon [svgIcon]="svgIcon"></mat-icon>
    } @else {
      <mat-icon>{{ matIcon }}</mat-icon>
    }
  </button>
</div>
